import { Badge } from 'braid-design-system';

import {
  DISPLAY_LABEL_FOR_DESCRIPTION,
  isValidDescriptionCode,
} from './DescriptionCode.ts';

const statusBadgeTones = {
  BadResponse: 'critical',
  InvalidUrl: 'critical',
  RequestTimeout: 'caution',
  Success: 'positive',
} as const;

interface RequestStatusBadgeProps {
  description: string;
  code: number;
}

export const RequestStatusBadge = ({
  description,
  code,
}: RequestStatusBadgeProps) => {
  if (!isValidDescriptionCode(description)) {
    return <Badge tone="neutral">Unknown status</Badge>;
  }

  return (
    <Badge
      tone={statusBadgeTones[description]}
    >{`${code} ${DISPLAY_LABEL_FOR_DESCRIPTION[description]}`}</Badge>
  );
};
